import { render } from "./promotion.vue?vue&type=template&id=193d8124&scoped=true"
import script from "./promotion.vue?vue&type=script&lang=js"
export * from "./promotion.vue?vue&type=script&lang=js"

import "./promotion.vue?vue&type=style&index=0&id=193d8124&lang=scss&scoped=true"

import exportComponent from "/Users/ruslan/Desktop/birch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-193d8124"]])

export default __exports__